
const APP_ID = 'TVOЁ_debug';
const APP_NAME = 'TVOЁ';
const APP_URL = 'https://app.tvoe.live?device=smart-tv&installed=vidaa';

const installFunction = (preview, setDownloadStatus) => {


  if (typeof window.Hisense_installApp !== 'function') {
    setDownloadStatus('Impossible');
    return;
  }

  window.Hisense_installApp(
    APP_ID,
    APP_NAME,
    preview,
    preview,
    preview,
    APP_URL,
    'store',
    (res) => {
      if (res === 0) {
        setDownloadStatus('Success');
      } else {
        setDownloadStatus('Impossible');
      }
    }
  );
};

export default installFunction;
